import { type UserProfile } from '@/types';
import { TENANT } from '@/utils/helpers';

/* Sets up heap profile */
export const heapSetup = (userProfile: UserProfile) => {
  if (typeof heap === 'undefined') {
    console.info('Heap is not registered in the window object');
    return;
  }

  const profile = JSON.parse(JSON.stringify(userProfile));

  Object.keys(profile).forEach((k) => {
    const value = profile[k];
    profile[k] = typeof value === 'string' ? value : JSON.stringify(value);
  });
  profile.tenant = TENANT;
  delete profile.avatar;

  heap.identify(profile.email);
  heap.addUserProperties(profile);
};
